/**
 * Plays muted loop videos only when they enter the viewport; pauses when off-screen.
 * Keeps posters (from Shopify video_tag image_size) visible until then.
 * Skips in theme editor (Shopify.designMode) and when prefers-reduced-motion: reduce.
 */
(function () {
  if (window.__swoopLazyAutoplayInit) return;
  window.__swoopLazyAutoplayInit = true;

  var videos = document.querySelectorAll('video.swoop-lazy-autoplay-video');
  if (!videos.length) return;

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    videos.forEach(function (v) {
      v.play().catch(function () {});
    });
    return;
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (!window.IntersectionObserver) {
    videos.forEach(function (v) {
      v.play().catch(function () {});
    });
    return;
  }

  var opts = { root: null, rootMargin: '100px 0px', threshold: 0.2 };

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        v.play().catch(function () {});
      } else {
        v.pause();
      }
    });
  }, opts);

  videos.forEach(function (v) {
    io.observe(v);
  });
})();
